import { render, staticRenderFns } from "./QuestionnaireCard1.vue?vue&type=template&id=7ce1c072&scoped=true&"
import script from "./QuestionnaireCard1.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireCard1.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireCard1.vue?vue&type=style&index=0&id=7ce1c072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce1c072",
  null
  
)

export default component.exports